export default "__VITE_ASSET__BmtBuVcd__"